import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function createAdminGroup(ids, subsIds, groupName) {
	return fetch(
		`${ENDPOINT_URL}/admingroup`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				ids,
				subsIds,
				groupName,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
